import {HostListener, Component, TemplateRef, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import {AppService} from './app.service';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component
import { AuthenticationService } from './services/authentication.service';
import { VersionCheckService } from './services/version-check.service';
import { ConstantConfigService } from './services/constant-config.service';
import { DataService } from './services/data.service';
import { SignImageService} from './services/sign-image.service';
import { Router,NavigationStart , CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserIdleService } from 'angular-user-idle';
import { CookieService } from 'ngx-cookie-service';
import { Subject, Subscription } from 'rxjs';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'tmd';
  public spinkit = Spinkit;
  spinner : boolean = false;
  @ViewChild('errorfoundsite', { static: true }) errorfoundsite: ElementRef;
  @ViewChild('error401site', { static: true }) error401site: ElementRef;

  userActivity;
  userInactive: Subject<any> = new Subject();
  constructor(
    private service : AppService,
    private bnIdle: BnNgIdleService,
    private authService: AuthenticationService,
    private versionCheckService: VersionCheckService,
    private router: Router,
    private toaster : ToastrService,
    public dataService: DataService,
    public signService: SignImageService,
    private userIdle: UserIdleService,
    private cookieService: CookieService
    ){
    this.updateSpinner()
    this.signService.modalRefer = this.errorfoundsite;
    this.signService.modalRefer401 = this.error401site;
  }

  ngOnInit(): void {
    //alert('session testing');
    //console.log(ConstantConfigService.versionJonPath);

    //code for route hash handling
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!!event.url && event.url.match(/^\/#/)) {
          let eventurl = event.url;
          if(eventurl.indexOf('app.hubspot.com') > -1){
            this.router.navigate([event.url.replace('/#', '')]);
          } else {
            this.router.navigate([event.url.replace('/#', '')]);
          }
        }
      }
    });

    this.versionCheckService.initVersionCheck(ConstantConfigService.versionJonPath);
    //console.log('authenticated',this.authService.isAuthenticated());
    /*if (this.authService.isAuthenticated()){
      console.log('is Authenticated')
      //this.versionCheckService.refreshTokens();
    } else {
      console.log('not authenticated');
    }*/

    /*this.bnIdle.startWatching(30).subscribe((isTimedOut: boolean) => {
      console.log('inside non activity')
      console.log('isTimedOut',isTimedOut);
      if (isTimedOut) {
        console.log('inside isTimedOut',isTimedOut);
        if (this.authService.isAuthenticated()){
          console.log('inside authenticated',isTimedOut);
           if (document.getElementsByClassName("modal").length === 0) {
            //do something...
          } else {
            // do something when a modal is open
            this.signService.closeModal();
          }
          this.authService.logout();
          this.toaster.error("","User logged out due to non activity");
          this.router.navigate(['/login']);
          console.log('session logout');
        }
      }
    });*/
  }

  ngAfterViewInit() {
    this.signService.modalRefer = this.errorfoundsite;
    this.signService.modalRefer401 = this.error401site;
  }

  updateSpinner(){
    this.service.getLoader.subscribe(
      message=>{
        this.spinner = message;
        // setTimeout(() => {
        //   this.service.setLoader(true);
        // }, 7000);
      }
    )

  }

  closeModal() {
    this.signService.closeModal();
  }

  closerefreshModal() {
    this.signService.closeModal();
    let minutes = 1;
    const myDate: Date = new Date();
    let add2min = myDate.getTime() + minutes*60000;
    let addMin = new Date(add2min);
    this.cookieService.set('hash_changes_load','1',addMin);
    window.location.reload();
  }

  stop() {
    console.log('stopping timer');
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
    localStorage.setItem('actiontaken','0');
  }

  @HostListener('document:click') refreshUserState() {
    console.log('mouse clicked');
    let lasteventtime:any = new Date().getTime();
    localStorage.setItem('lastEventTime',lasteventtime);
    localStorage.setItem('actiontaken','1');
    setTimeout(() =>{
      this.stop();
    this.restart();
    },1000);

  }

  /*@HostListener('window:mousemove') refreshUserState() {
    console.log('mouse moved');
    this.restart();
  }*/

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    console.log('any key is pressed');
    let lasteventtime:any = new Date().getTime();
    localStorage.setItem('lastEventTime',lasteventtime);
    localStorage.setItem('actiontaken','1');

    setTimeout(() =>{
      this.stop();
      this.restart();
    },1000);
  }

}